import {Map, fromJS, List} from "immutable";

import {
    GET_SUPPLIERS_SUCCESS,
    GET_SUPPLIERS_REQUEST,
    GET_SUPPLIERS_ERROR,
    GET_SUPPLIER_REQUEST,
    GET_SUPPLIER_SUCCESS,
    GET_SUPPLIER_ERROR,
    CREATE_SUPPLIER_REQUEST,
    CREATE_SUPPLIER_SUCCESS,
    CREATE_SUPPLIER_ERROR,
    UPDATE_SUPPLIER_REQUEST,
    UPDATE_SUPPLIER_SUCCESS,
    UPDATE_SUPPLIER_ERROR,
    CHANGE_STATUS_SUPPLIER_REQUEST,
    CHANGE_STATUS_SUPPLIER_SUCCESS,
    CHANGE_STATUS_SUPPLIER_ERROR,
    DELETE_SUPPLIER_REQUEST,
    DELETE_SUPPLIER_SUCCESS,
    DELETE_SUPPLIER_ERROR,
    CLEAN_SUPPLIERS
} from '../actions/suppliers';

const suppliers = (state = Map({
  payload: List([]),
  isFetching: false,
  error: false
}), action) => {
  let newState, updatedPayload, index, payload = state.get('payload');
  switch (action.type) {

      // Requests
      case GET_SUPPLIERS_REQUEST:
      case GET_SUPPLIER_REQUEST:
      case CREATE_SUPPLIER_REQUEST:
      case UPDATE_SUPPLIER_REQUEST:
      case CHANGE_STATUS_SUPPLIER_REQUEST:
      case DELETE_SUPPLIER_REQUEST:
          newState = state.merge({
              isFetching: action.isFetching,
              error: action.error
          });
          return newState;

      // Success
      case GET_SUPPLIERS_SUCCESS:
      case GET_SUPPLIER_SUCCESS:
      case CLEAN_SUPPLIERS:
          newState = state.merge({
              payload: fromJS(action.payload),
              isFetching: action.isFetching,
              error: action.error
          });
          return newState;

      case CREATE_SUPPLIER_SUCCESS:

          // Check if payload is a List (Array)
          if(List.isList(payload)) {
              updatedPayload = payload.push(fromJS(action.payload));

              // If payload is a Map the payload to be updated is action.payload itself
          } else if(Map.isMap(payload)) {
              updatedPayload = fromJS(action.payload);
          }

          newState = state.merge({
              isFetching: action.isFetching,
              error: action.error,
              created: action.created,
              payload: updatedPayload
          });
          return newState;

      case UPDATE_SUPPLIER_SUCCESS:
      case CHANGE_STATUS_SUPPLIER_SUCCESS:

          // Check if payload is a List (Array)
          if(List.isList(payload)) {

              // Find the index of the supplier to be updated inside the List
              index = payload.findIndex(item => {
                  return item.get('_id') === action.payload._id;
              });

              // Update the payload list
              if (index !== -1) {
                  updatedPayload = payload.update(index, () => {
                      return fromJS(action.payload);
                  });
              }


              // If payload is a Map the payload to be updated is action.payload itself
          } else if(Map.isMap(state.get('payload'))) {
              updatedPayload = fromJS(action.payload);
          }
          newState = state
              .merge({
                  isFetching: action.isFetching,
                  error: action.error,
                  updated: action.updated,
                  payload: updatedPayload
              });
          return newState;
      case DELETE_SUPPLIER_SUCCESS:
          updatedPayload = payload.filter( supplier => {
              return supplier.get('_id') !== action.payload._id;
          });
          newState = state.merge({
              payload: updatedPayload,
              isFetching: action.isFetching,
              error: action.error
          });
          return newState;

      // Errors
      case GET_SUPPLIERS_ERROR:
      case GET_SUPPLIER_ERROR:
      case CREATE_SUPPLIER_ERROR:
      case UPDATE_SUPPLIER_ERROR:
      case CHANGE_STATUS_SUPPLIER_ERROR:
      case DELETE_SUPPLIER_ERROR:
          newState = state.merge({
              isFetching: action.isFetching,
              error: action.error,
              errorMessage: action.errorMessage
          });
          return newState;
      default:
          return state;
  }
};

export default suppliers;



// WEBPACK FOOTER //
// ./src/reducers/suppliers.js